/** @format */

import React from 'react'
import styled from 'styled-components'
import { _$, Button, Card, Message } from '@king-design/react'
import { useParams, useHistory } from 'react-router'
import MonitorCrumb from 'src/components/MonitorCrumb'
import { get } from 'lodash'
import Readonly from '../Trigger/components/RuleDrawer/Readonly'
import { getTriggerDetail } from 'src/api/ApiEventOpsTrigger'
import { useAsync } from 'react-use'
import { request } from 'src/utils'
import API from 'src/api/ApiContacts'
import APIEventCenter from 'src/api/ApiEventCenter'
import { applyAudit } from 'src/api/ApiEventOpsTrigger'

const Approve: React.FC<{ className?: string }> = ({ className }) => {
  const params = useParams()
  const Module = get(params, 'Module')
  const ID = get(params, 'ID')
  const history = useHistory()

  const { value: triggerDetail } = useAsync(async () => {
    if (Module === 'trigger') {
      return getTriggerDetail({ ID })
    }
  }, [Module, ID])

  // 联系人/联系组
  const { value: reciverResult } = useAsync(async () => {
    const userResult = await request(API.getAlertUser, {
      method: 'get',
      data: {
        PageIndex: 1,
        Cap: 1
      }
    })

    const groupResult = await request(API.getUserGroup, {
      method: 'get',
      data: {
        PageIndex: 1,
        Cap: 1
      }
    })
    return {
      userlist: userResult.data?.userlist || [],
      grouplist: groupResult.data?.usergrplist || []
    }
  }, [])

  // 事件
  const { value: eventResult } = useAsync(async () => {
    const result = await request(APIEventCenter.getListSysEvents, {
      data: {
        ProductType: 999
      }
    })
    if (result && result?.code === 'Success' && result?.data.eventList) {
      return result?.data.eventList
    }
  }, [])

  // 审批
  const onApplyAudit = async (Status: -2 | -1 | 2) => {
    const result = await applyAudit({
      Module,
      TargetID: parseInt(ID),
      Status
    })
    if (result) {
      if (Status === -2) {
        Message.success('审批撤回成功')
      } else if (Status === -1) {
        Message.success('审批驳回成功')
      } else if (Status === 2) {
        Message.success('审批通过成功')
      }
      if (Module === 'trigger') {
        history.push(`/monitor/eventops/trigger`)
      }
    }
  }
  return (
    <div className={className}>
      <MonitorCrumb breadArr={[{ title: _$('自动化运维') }, { title: _$(' 审批详情') }]} />
      <Card className="card_body" style={{ marginBottom: 16 }}>
        {Module === 'trigger' ? (
          <Readonly
            record={triggerDetail}
            sceneInput={[]}
            eventResult={eventResult}
            reciverResult={reciverResult}
          />
        ) : null}
      </Card>
      <div className="button_row">
        {/* <Button
          type="danger"
          disabled={!triggerDetail?.Approving}
          onClick={() => {
            onApplyAudit(-2)
          }}
        >
          撤回
        </Button> */}
        <Button
          disabled={!triggerDetail?.Approving}
          onClick={() => {
            onApplyAudit(-1)
          }}
        >
          驳回
        </Button>
        <Button
          disabled={!triggerDetail?.Approving}
          type="primary"
          onClick={() => {
            onApplyAudit(2)
          }}
        >
          通过
        </Button>
      </div>
    </div>
  )
}

export default styled(Approve)`
  position: relative;
  padding-bottom: 64px;
  .card_body {
    height: calc(100vh - 166px);
    overflow-y: auto;
  }
  .button_row {
    position: absolute;
    right: 0;
    bottom: 0;
    background-color: #fff;
    height: 64px;
    border-top: 1px solid #e8e8e8;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding: 0 16px;
    .k-btn {
      margin-left: 8px;
    }
  }
`
